import content from '../../../data/content.json';

export default function ImpactSection() {
  return (
    <section id="impact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="h-px w-10 bg-teal-500"></div>
            <span className="text-sm font-semibold text-teal-600 uppercase tracking-wider">{content.impact.sectionSubtitle}</span>
            <div className="h-px w-10 bg-teal-500"></div>
          </div>
          <h3
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {content.impact.sectionTitle}
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {content.impact.sectionDescription}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {content.impact.testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-2xl p-8 border border-gray-100 flex flex-col">
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-amber-400 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 leading-relaxed italic flex-1 mb-6">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-gray-100">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-12 h-12 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <div className="font-semibold text-gray-900 text-sm">{t.name}</div>
                  <div className="text-gray-500 text-xs">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-3xl p-10 md:p-14 text-center text-white">
          <h3
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            {content.impact.ctaTitle}
          </h3>
          <p className="text-teal-100 text-lg mb-8 max-w-xl mx-auto">
            {content.impact.ctaDescription}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => {
                const el = document.getElementById('get-help');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-10 py-4 bg-white text-teal-700 font-semibold rounded-xl hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer text-lg"
            >
              Request Support
            </button>
            <button
              onClick={() => {
                const el = document.getElementById('contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-10 py-4 bg-white/10 border border-white/30 text-white font-semibold rounded-xl hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer text-lg"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
